import { Card, Progress } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { UploadVideoInterface } from 'type/uploadVideoType';
import './TranscodeFileUpload.css';

interface TranscodeFileUploadProps {
  uploadVideo?: UploadVideoInterface;
}

const TranscodeFileUpload: React.FC<TranscodeFileUploadProps> = ({ uploadVideo }) => {
  useEffect(() => {}, [uploadVideo]);

  return (
    <Card title="Original Video Upload Status">
      {uploadVideo && (
        <Card className="upload-video-list-item" hoverable>
          <div className="file-info">
            <div className="file-name">{uploadVideo?.name}</div>
            <div className="progress-bar">
              <Progress
                percent={uploadVideo?.percent || 0}
                status={
                  uploadVideo?.state === 'normal'
                    ? 'normal'
                    : uploadVideo?.state === 'uploading'
                      ? 'active'
                      : uploadVideo?.state === 'uploaded'
                        ? 'success'
                        : 'exception'
                }
                format={percent =>
                  `${(percent || 0).toFixed(2)}% / ${((uploadVideo?.speed || 0) / 1024 / 1024).toFixed(2)} MB/s`
                }
              />
            </div>
          </div>
        </Card>
      )}
    </Card>
  );
};

export default observer(TranscodeFileUpload);
